import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Card, Button, Icon, Image, Label } from "semantic-ui-react";
import { openModal } from "../../features/modals/modalActions";
import { selectedTest } from "../../features/selections/selectActions";
import { createTestTree } from "../../features/userTestTree/userTestTreeActions";
import CardImage from "../Images/culture.jpg";
import firebase from "firebase";
import "firebase/firestore";
import LoadingComponent from "../LoadingComponent/LoadingComponent";

const actions = {
    openModal,
    selectedTest,
    createTestTree
};

const mapState = state => ({
    auth: state.firebase.auth,
    selectedCollection: state.selection.selectedCategory,
    selectedTest: state.selection.selectedTest,
    testTree: state.userTestTreeReducer.testTree
});

class CategoryTestsPage extends Component {
    state = {
        testRef: {},
        loading: true
    };

    async componentDidMount() {
        // if (this.props.location.query) {
        // let value = this.props.location.query.value;
        // let testCategory = "CategoryTests";
        const { selectedCollection, createTestTree, auth } = this.props;
        let testRef = await firebase
            .firestore()
            .collection(selectedCollection)
            .orderBy("createdAt", "asc")
            .get();
        // console.log("testRef", this.state.testRef.docs);
        this.setState({
            testRef,
            loading: false
        });
        await createTestTree(auth.uid);
        //  }
    }

    redirectToTestPage = value => () => {
        const { selectedTest } = this.props;
        selectedTest(value.data().testId);

        this.props.history.push({
            pathname: "/testDetailPage"
        });
    };

    isTaken = testId => {
        const { selectedCollection, testTree } = this.props;
        if (testTree["testTree"]) {
            if (testTree["testTree"].hasOwnProperty(selectedCollection)) {
                let testArray = testTree["testTree"][selectedCollection];
                for (let i = 0; i < testArray.length; i++) {
                    if (testId === testArray[i]) {
                        return true;
                    }
                }
            }
            return false;
        }
    };

    render() {
        // console.log("render called");
        const { auth } = this.props;
        const isUserLoggedIn = auth.isLoaded && !auth.isEmpty;
        // console.log(isUserLoggedIn ? "User Logged" : "Not logged");
        // console.log("calling");
        if (this.state.loading) return <LoadingComponent inverted={true} />;
        return (
            <Grid>
                <Grid.Row style={{ justifyContent: "center" }}>
                    {this.state.testRef.docs &&
                        this.state.testRef.docs.map((value, index) => (
                            <Grid.Column
                                key={index}
                                mobile={16}
                                tablet={8}
                                computer={4}
                            >
                                <Card
                                    style={{
                                        marginRight: "20px",
                                        marginTop: "20px",
                                        width: "100%"
                                    }}
                                >
                                    <Image src={CardImage} />
                                    <Card.Content>
                                        <Card.Header>
                                            {this.state.testRef.docs[index].id}
                                        </Card.Header>
                                        {this.isTaken(
                                            this.state.testRef.docs[index].id
                                        ) && (
                                            <Label as="a" color="red" ribbon>
                                                Taken
                                            </Label>
                                        )}
                                        <Card.Description>
                                            Lorem Ipsum is simply dummy text of
                                            the printing and typesetting
                                            industry. Lorem Ipsum has been the
                                            industry's
                                        </Card.Description>
                                    </Card.Content>
                                    <Card.Content extra>
                                        <Button
                                            primary
                                            // as={Link}
                                            // to={"/testDetailPage"}
                                            onClick={
                                                isUserLoggedIn
                                                    ? this.redirectToTestPage(
                                                          this.state.testRef
                                                              .docs[index]
                                                      )
                                                    : () => {
                                                          this.props.openModal(
                                                              "LoginModal"
                                                          );
                                                      }
                                            }
                                            animated="vertical"
                                        >
                                            <Button.Content hidden>
                                                Take
                                            </Button.Content>
                                            <Button.Content visible>
                                                <Icon name="pencil" />
                                            </Button.Content>
                                        </Button>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        ))}
                </Grid.Row>
            </Grid>
        );
    }
}

export default connect(
    mapState,
    actions
)(CategoryTestsPage);
